import { surveyQuestionLibraryStore } from "../stores";

export const useQuestionLibraryStore = () => surveyQuestionLibraryStore;
